$(window).on('scroll', function() {

  if ($(this).scrollTop() > 100) {
      $('.textbar').slideUp(200);
  };
  if ($(this).scrollTop() < 80) {
      $('.textbar').slideDown(200);
  };
  
  if ($(this).scrollTop() > 400) {
      $('.logo-xx').addClass('xxon');
  } else {
      $('.logo-xx').removeClass('xxon');
  };

  $('.h2-glow').each(function() {
    let $el = $(this);
    let elTop = $el.offset().top;
    let scrollBottom = $(window).scrollTop() + $(window).height();

    if (scrollBottom - 300 >= elTop) {
      $el.addClass('blu');
    } else {
      $el.removeClass('blu');
    }
  });
});

$(document).ready(function() {
  
  $('.svg-aro').on('click', function () {
    var $aro = $(this);
    var $parent = $aro.parent();
    var $grandparent = $parent.parent();
    var $swipeFeat = $grandparent.siblings('.swipe-feat');
  
    if (!$swipeFeat.length) return;
    if ($aro.is($parent.children().eq(0))) {
      $swipeFeat.animate({ scrollLeft: $swipeFeat.scrollLeft() - 380 }, 600);
    }
    else if ($aro.is($parent.children().eq(1))) {
      $swipeFeat.animate({ scrollLeft: $swipeFeat.scrollLeft() + 380 }, 600);
    }
  });  
   
  $(".menu").click(function(){
    if ($(window).scrollTop() < 100 && $(this).hasClass('menuon')) {
        $('.textbar').slideDown(200);
    } else if ($(window).scrollTop() < 100) {
        $('.textbar').slideUp(200);
    }
    $(this).toggleClass('menuon');
    $(".menuspot").toggleClass('menuin');
    $(".navdim").fadeToggle();
    $('#ln1').toggleClass('ln-and1');
    $('#ln2').toggleClass('ln-and2');
    $('#ln3').toggleClass('ln-and3');
    $('body').toggleClass('noscroll');
    $('.dropdim').fadeOut();
  });


    $('.drop-ft').click(function() {
      $(this).next('.ul-ft').slideToggle(300);
      $(this).find('.plusbox').toggleClass('tominus');
    });
    //dropdown
    $('.drop').on('click', function () {
    $(this).next('.drop-down').toggle();
    if ($(this).next('.drop-down').is(':visible')) {
        $(this).children('.aro-dd').addClass('aro180');
    } else {
        $(this).children('.aro-dd').removeClass('aro180');
    }
    });
    
  
  $(".navdim").hover(function(){
    $(".menu").toggleClass('menuon');
    $(".megamenu").removeClass('megaon');
    $(".navdim").fadeOut(200);
  });

  $('.link-dd').click(function() {
    $(this).children('.row-dd').slideToggle(100);
    $(this).next('.dropdown').toggle();
    if ($(this).next('.dropdown').is(':visible')) {
      $(this).children('.aro-dd').addClass('aro180');
    } else {
      $(this).children('.aro-dd').removeClass('aro180');
    }
    $(".dropdim").fadeToggle();
  });
  
  $(".link-dd").hover( function() {
    $(".dropdown").hide();
    $(this).next('.dropdown').show();
    if ($(this).next('.dropdown').is(':visible')) {
      $(this).children('.aro-dd').addClass('aro180');
    } else {
      $(this).children('.aro-dd').removeClass('aro180');
    }    
    $(".dropdim").fadeIn();
  }, function() {
  });
  
  $(".dropdim").hover( function() {
    $(".dropdown").hide();
    $(this).fadeOut();
  }, function() {
  });
  
  $('#searchbar').click(function() {
    $(this).toggleClass('svg-on');
    $('.go-find').toggle();
    $('.go-search').focus();
  }); 
  
  $('.dd-foot').click(function() {
    $(this).next('.ul-foot').slideToggle(300);
    $(this).find('.plusbox').toggleClass('tominus');
  });
  
  $(".varr").hover( function() {
    $(this).siblings().removeClass('varion');
    $(this).addClass('varion');    
    var thisimg = $(this).data('img');
    $(this).parents('li').find('.img').attr('src',thisimg);   
    var thislink = $(this).attr('href');
    $(this).closest('li').find('> a').attr('href', thislink);
    var thisvar = $(this).data('var');    
    var thisname = $(this).data('name');
    $(this).parents('li').find('.i4i').text(thisname); 
  }, function() {
    $(this).parents('li').find('.img').fadeIn();
  });

  $(".varis").hover( function() {
    $(this).siblings().removeClass('varion');
    $(this).addClass('varion');    
    var thisimg = $(this).data('img');
    $(this).parents('li').find('.img').attr('src',thisimg);    
    var thisvar = $(this).data('var');    
    var thisname = $(this).data('name');
    $(this).parents('li').find('.h3t').text(thisname); 
  }, function() {
    $(this).parents('li').find('.img').fadeIn();
  });

  setInterval(function() {
    $('.glow').siblings().each(function() {
      $(this).toggleClass('noglow');
    });
  }, 5000);
  
  setTimeout(function() {
    $('.blubar').removeClass('barout');
  }, 2000);

  $('.droprow').click(function() {
    $(this).children('.row-dd').slideToggle(100);
    $(this).toggleClass('bgf');
    $(this).find('.plusbox').toggleClass('tominus');
  });

  $('.aro-left').click(function() {
    $(this).closest('.flex-bar').siblings('.swipe-feat').find('.ul-swipe').animate({ scrollLeft: '-=200' }, 300);
  });
  $('.aro-right').click(function() {
    $(this).closest('.flex-bar').siblings('.swipe-feat').find('.ul-swipe').animate({ scrollLeft: '+=200' }, 300);
  });
  
});

$(window).on('scroll', function() {
  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();
  const footerTop = $('footer').offset().top;
  const footerInView = (scrollTop + windowHeight) >= (footerTop - 50);

  if (footerInView) {
    $('.buy-box').css('bottom', '-120px');
  } else if (scrollTop > 500) {
    $('.buy-box').css('bottom', '0px');
  } else {
    $('.buy-box').css('bottom', '-120px');
  }
});